class RecentlyViewed extends HTMLElement {
    constructor() {
        super();

        this.storageKey = this.getAttribute('key') || '_recent-products'
        this.limit = this.getAttribute('limit') || 4;
        this.langPrice = this.getAttribute('langPrice') || 'Regular price';
        this.langSale = this.getAttribute('langSale') || 'Sale price';

        this.storeProduct();

        this.observer = new IntersectionObserver(
            this.renderStorage.bind(this)
        );

        this.observer.observe(this);
    }

    renderStorage () {
        this.innerHTML = this.storage
            .map(
                this.renderStorageItem.bind(this)
            )
            .splice(0, this.limit)
            .reverse()
            .join(' ');

        this.observer.disconnect();
    }

    renderStorageItem (item) {
        if (item.url === this.getAttribute('url'))
            return '';

        return `
            <div class="grid__item">
                <div class="card-wrapper">
                    <div class="card product-card card--standard card--media" style="--ratio-percent: 100%;">
                        <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
                            ${this.renderStorageItemMedia(item)}
                        
                            <div class="card__content">
                                <div class="card__information">
                                    <h3 class="card__heading line-clamp">
                                        <a href="${item.url}" class="full-unstyled-link">
                                            ${item.title}
                                        </a>
                                    </h3>
                                </div>
                                
                                ${this.renderStorageItemBadge(item)}
                            </div>
                        </div>
                        
                        
                        <div class="card__content">
                            <div class="card__information">
                                <h3 class="card__heading line-clamp h5">
                                    <a href="${item.url}" class="full-unstyled-link">
                                      ${item.title}
                                    </a>
                                </h3>
                           
                            
                                <div class="card-information--no-heading">
                                     <div>&nbsp;</div>
                                     ${this.renderStorageItemPrice(item)}
                                </div>
                            </div>
                        </div>
                        ${this.renderStorageItemBadge(item)}
                    </div>
                </div>
            </div>                        
        `;
    }

    renderStorageItemBadge (item) {
        if (
            !item.compare_at_price ||
            item.compare_at_price === 0 ||
            item.compare_at_price >= item.price
        ) return '';

        return `
            <div class="card__badge bottom left">
                <span class="badge badge--bottom-left color-accent-2">
                    Sale
                </span>
           </div>
        `;
    }

    renderStorageItemMedia (item) {
        return `
            <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                    <img 
                        src="${item.image}" 
                        alt="${item.alt}" 
                        width="${item.width}" 
                        height="${item.height}"
                        class="motion-reduce" 
                        loading="lazy"
                    >
                </div>
            </div>
        `;
    }

    renderStorageItemPrice (item) {
        return `
            <div class="price${item.price < item.compare_at_price ? ' price--on-sale' : ''}">
                <div class="price__container">
                    <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">
                            ${this.langPrice}
                        </span>
                          <span class="price-item price-item--regular">
                            ${Shopify.formatMoney(item.price, Shopify.money_format)}
                          </span>
                    </div>
                    <div class="price__sale">
                        <span class="visually-hidden visually-hidden--inline">
                            ${this.langPrice}
                         </span>
                        <span>
                          <s class="price-item price-item--regular">
                              ${Shopify.formatMoney(item.compare_at_price, Shopify.money_format)}
                          </s>
                        </span>
                        <span class="visually-hidden visually-hidden--inline">
                            ${this.langSale}
                        </span>
                        <span class="price-item price-item--sale price-item--last">
                            ${Shopify.formatMoney(item.price, Shopify.money_format)}
                        </span>
                    </div>
                </div>
            </div> 
        `;
    }

    storeProduct () {
        const data = {
            title: this.getAttribute('title'),
            image: this.getAttribute('image'),
            alt: this.getAttribute('alt'),
            width: this.getAttribute('width'),
            height: this.getAttribute('height'),
            price: this.getAttribute('price'),
            url: this.getAttribute('url')
        }

        localStorage.setItem(this.storageKey,
            JSON.stringify(
                this.storage
                    .filter(p => p.url !== data.url)
                    .splice(0, this.limit + 1)
                    .concat(data)
            )
        )
    }

    get storage () {
        const data = localStorage.getItem(this.storageKey);

        if (data)
            try {
                return JSON.parse(data)
            } catch {
                return [];
            }

        return [];
    }
}

customElements.define('recently-viewed', RecentlyViewed);
